module.exports = __webpack_public_path__ + "img/video-2.161941b9.png";